import { Link } from "react-router";
import { useCurrentRoute } from "../../../data/hooks";

export default function MenuItem({
  path,
  title,
}: {
  path: string;
  title: string;
}) {
  const curRoute = useCurrentRoute();
  const classes = ["H6"];
  if (curRoute !== path) {
    classes.push("wish-text-primary");
  }

  return (
    <div className="p-2">
      <Link className={classes.join(" ")} to={path} viewTransition>
        {title}
      </Link>
    </div>
  );
}
